import { urlModifier } from 'swag-client-common/libs/url-modifier';
import { prefetchFailure, prefetchSuccess } from '../redux/prefetch/prefetch.actions';
import { apiCall } from './api-call';
export const additionalPrefetchCalls = [apiCall(urlModifier('/api/v1/prefetch'), prefetchSuccess, prefetchFailure)];